export default function Cruising() {
  const cruisingOptions = [
    {
      title: 'Catamarans',
      description: 'Offers exceptional stability and spacious living areas for a premium comfort experience. Its twin-hull design and shallow draft allow for safe access to secluded bays and shallow anchorages.',
      image: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/cde6a9073a0c800efdc9790cc8b356c0.jpeg',
      duration: '3 hours',
      capacity: 'Up to 12 guests'
    },
    {
      title: 'Monohulls',
      description: 'Delivers an authentic sailing experience with superior upwind performance and classic aesthetics. Known for its responsive handling, it remains the top choice for traditional sailing enthusiasts.',
      image: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/eac6ab61d4a3c1ac41fdaddc02255c82.jpeg',
      duration: 'Full day',
      capacity: 'Up to 16 guests'
    },
    {
      title: 'Gulets',
      description: 'Combines traditional craftsmanship with modern luxury, providing vast deck space ideal for large groups. These classic wooden vessels offer a steady, heritage-rich cruising experience unique to the Mediterranean.',
      image: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/828ba604fc3471d225c5e17096d2a6ee.jpeg',
      duration: '5 hours',
      capacity: 'Up to 10 guests'
    },
    {
      title: 'Motoryachts',
      description: 'Prioritizes speed and efficiency, allowing for quick transitions between destinations. With versatile layouts and modern amenities, it offers a reliable and streamlined cruising experience.',
      image: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/53c89907884773ad98fe361a189a3dea.webp',
      duration: 'Flexible',
      capacity: 'Custom'
    }
  ];

  return (
    <section id="cruising" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Cruising Experiences
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Embark on unforgettable sailing adventures designed for relaxation, exploration, and creating lasting memories on the water
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cruisingOptions.map((option, index) => (
            <div
              key={index}
              className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={option.image}
                  alt={option.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <h3 className="absolute bottom-4 left-4 text-2xl font-bold text-white">
                  {option.title}
                </h3>
              </div>
              <div className="p-6">
                <p className="text-gray-700 mb-4 leading-relaxed">
                  {option.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
